module.exports = __webpack_public_path__ + "9d6694509bd145ef1345068950476603.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/practice-question-3.png
// module id = 1716
// module chunks = 0